import axios, { AxiosResponse } from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { IMerchantOrdersInvoice } from '../../interfaces/common/merchant-invoices';
import { AuthContext } from '../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../configurations/global.config';
import {
  Alert,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
} from '@mui/material';
import { ErrorsFlattenner } from '../common/errors-flattenner/errors-flattenner';
import EditingInvoice from '../delivery-company-components/accouting/invoices/editing-invoice';
import { ClearIcon } from '@mui/x-date-pickers';
import { on } from 'events';
import { isMobile, isTablet } from 'react-device-detect';
import editingInvoice from '../delivery-company-components/accouting/invoices/editing-invoice';
import CustomDialog from '../common/custom-dialog/custom-dialog';

interface MerchantInvoiceLookupDialogProps {
  invoice_id: string;
  onClose: () => void;
}

function MerchantInvoiceLookupDialog({
  invoice_id,
  onClose,
}: MerchantInvoiceLookupDialogProps) {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<AxiosResponse>();
  const [invoice, setInvoice] = useState<IMerchantOrdersInvoice>();
  const [message, setMessage] = useState('');
  const { user, config } = useContext(AuthContext);

  useEffect(() => {
    setLoading(true);
    setResponse(undefined);
    const fetchInvoice = async () => {
      try {
        const response = await axios.get<IMerchantOrdersInvoice>(
          `${API_ENDPOINT}/api/v1/merchant-invoice/${invoice_id}/`,
          config
        );
        setResponse(response);
        setInvoice(response.data);
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setResponse(e.response);
          setMessage('Failed to find invoice: ' + e.response?.statusText);
        }
        setMessage('Failed to find invoice');
      }
      setLoading(false);
    };

    fetchInvoice();
  }, [invoice_id]);
  return loading ? (
    <>
      Looking for invoice <CircularProgress />
    </>
  ) : (
    <>
      {message != '' && (
        <>
          <Alert
            severity={
              response && response.status >= 200 && response.status < 300
                ? 'success'
                : 'error'
            }
          >
            <>
              {message}

              {response && response.status >= 300 && (
                <ErrorsFlattenner rawErrors={response.data} />
              )}
            </>
          </Alert>
          <br />
        </>
      )}

      {invoice && (
        <CustomDialog
          open={editingInvoice != null}
          fullWidth
          maxWidth="xl"
          fullScreen={(isMobile && !isTablet)}
          onClose={onClose}
        >
          <div
            style={{
              textAlign: 'right',
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <IconButton onClick={onClose}>
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

          <DialogContent sx={{ overflow: 'visible', minHeight: 400 }}>
            <EditingInvoice
              invoice={invoice}
              updateInvoice={(invoice) => {
                /* nothing to do*/
              }}
            />
          </DialogContent>
        </CustomDialog>
      )}
    </>
  );
}

export default MerchantInvoiceLookupDialog;
